import React from 'react';
import PropTypes from 'prop-types';

import { LoadingSpinner } from '@motorway/motorway-component-library';

import styles from './LoadingWithText.module.scss';

const LoaderWithText = (props) => {
	const { hideLabel = false, message = null } = props;

	return (
		<div className={styles.spinner}>
			<LoadingSpinner size="large" />
			{hideLabel ? null : <div className={styles.spinnerText}>{message || 'Please wait…'}</div>}
		</div>
	);
};

LoaderWithText.propTypes = {
	hideLabel: PropTypes.bool,
	message: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};

export default LoaderWithText;
